import layout1 from './layout1/Layout1Config';
import layout2 from './layout2/Layout2Config';
import layout3 from './layout3/Layout3Config';
import i18next from 'i18next';
import en from './i18n/en';

i18next.addResourceBundle('en', 'fuse-layout', en);

const FuseLayoutConfigs = {
	layout1,
	layout2,
	layout3
};

export default FuseLayoutConfigs;
